import router, { useRouter } from 'next/router';
import { resetFilters } from '../helpers/search-filters';
import {
  SearchContext,
  SearchContextInterface
} from '../features/search-new/context/SearchContext';
import { useContext } from 'react';
import { styled } from 'styled-components';
import { logEvent } from '../new-lib/analytics';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';

const RemoveFilterNote = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const { searchFiltersDispatch, appliedFiltersCount, searchFiltersState } =
    useContext(SearchContext) as SearchContextInterface;

  const handleReset = () => {
    logEvent.search(
      'filter_reset',
      'dynamic_price_alert',
      'filter',
      searchFiltersState
    );
    resetFilters(router, searchFiltersDispatch, true);
  };
  if (appliedFiltersCount > 0) {
    return (
      <Container className="filter-note">
        <span>
          {isMobile && router.pathname.includes('/compound') && (
            <span className="highlight">*</span>
          )}
          {router.pathname.includes('/compound')
            ? t('prices_shown_reflect_filters')
            : t('prices_shown_reflect_filters_search')}
        </span>
        <button onClick={handleReset}>{t('clear_filter')}</button>
      </Container>
    );
  }
  return null;
};

const Container = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  border-radius: 8px;
  background: #e8f4ff;
  span {
    color: #2c3138;
    font-family: materialRegular;
    font-size: 14px;
  }
  .highlight {
    color: #ff9108;
    font-family: materialRegular;
    font-size: 10px;
  }

  button {
    color: #1e6dac;
    font-family: materialMedium;
    font-size: 12px;
    text-decoration: underline;
    background: transparent;
    border: 0px solid transparent;
    min-width: fit-content;
    text-align: end;
  }
  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    padding: 8px;
    /* gap: 8px; */
    span {
      font-size: 12px;
    }
  }
`;

export default RemoveFilterNote;
